export enum WrappingContainerSpacing {
  Normal = 'Normal',
  Wide = 'Wide',
  Wider = 'Wider',
  Tight = 'Tight',
  NoGap = 'NoGap',
}
